import { useContext } from "react";
import { injectIntl } from "react-intl";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails";

const MultiDeviceClockButtons = (props) => {
  const {
    clockState,
    intl,
    startButtonPressed,
    stopButtonPressed,
    onPitchButtonPressed,
    warmUpButtonPressed,
    warmingUpButtonPressed,
    endWarmingUpButtonPressed,
    throwOffButtonPressed,
    centrePassButtonPressed,
    startMatchButtonPressed,
    endPeriodButtonPressed,
    confirmPeriodButtonPressed,
    startPeriodButtonPressed,
    nextExtraPeriodButtonPressed,
    shootOutButtonPressed,
    endMatchButtonPressed,
    confirmFixtureButtonPressed,
  } = props;
  const { formatMessage } = intl;
  const { sport } = useContext(FixtureDetailsContext);

  return (
    <>
      {clockState === "stopped" && (
        <span className="md-start-button" onClick={startButtonPressed}>
          {formatMessage({
            id: "clock.start",
            defaultMessage: "Start",
          })}
        </span>
      )}
      {clockState === "running" && (
        <span className="md-stop-button" onClick={stopButtonPressed}>
          {formatMessage({
            id: "clock.stop",
            defaultMessage: "Stop",
          })}
        </span>
      )}
      {clockState === "waitingForOnPitch" && (
        <span className="md-start-button" onClick={onPitchButtonPressed}>
          {formatMessage({
            id: "clock.playersOnCourt",
            defaultMessage: "Players On Court",
          })}
        </span>
      )}
      {clockState === "waitingForWarmUp" && (
        <span className="md-start-button" onClick={warmUpButtonPressed}>
          {formatMessage({
            id: "clock.warmup",
            defaultMessage: "Warm Up",
          })}
        </span>
      )}
      {clockState === "waitingForWarmingUp" && (
        <span className="md-start-button" onClick={warmingUpButtonPressed}>
          {formatMessage({
            id: "clock.playersWarmingUp",
            defaultMessage: "Players Warming Up",
          })}
        </span>
      )}
      {clockState === "waitingForEndWarmingUp" && (
        <span className="md-stop-button" onClick={endWarmingUpButtonPressed}>
          {formatMessage({
            id: "clock.playersWarmingUp.end",
            defaultMessage: "End Players Warming Up",
          })}
        </span>
      )}
      {clockState === "waitingForThrowOff" && (
        <span className="md-start-button" onClick={throwOffButtonPressed}>
          {formatMessage({
            id: "clock.throwOff",
            defaultMessage: "Throw off",
          })}
        </span>
      )}
      {clockState === "waitingForCentrePass" && (
        <span className="md-start-button" onClick={centrePassButtonPressed}>
          {formatMessage({
            id: "clock.centrePass",
            defaultMessage: "Centre Pass",
          })}
        </span>
      )}
      {clockState === "waitingForStartMatch" && (
        <span className="md-start-button" onClick={startMatchButtonPressed}>
          {formatMessage({
            id: "clock.start.fixture",
            defaultMessage: "Start Match",
          })}
        </span>
      )}
      {clockState === "waitingForPeriodEnd" && (
        <span className="md-stop-button" onClick={endPeriodButtonPressed}>
          {formatMessage({
            id: "clock.end.period",
            defaultMessage: "End Period",
          })}
        </span>
      )}
      {clockState === "waitingForPeriodConfirm" && (
        <span className="md-stop-button" onClick={confirmPeriodButtonPressed}>
          {formatMessage({
            id: "clock.confirm.period",
            defaultMessage: "Confirm Period",
          })}
        </span>
      )}
      {clockState === "waitingForPeriodStart" && (
        <span className="md-start-button" onClick={startPeriodButtonPressed}>
          {formatMessage({
            id: "clock.start.period",
            defaultMessage: "Start Period",
          })}
        </span>
      )}
      {sport === "handball" && ["waitingForExtraPeriodStart", "shootOutInProgress"].includes(clockState) && (
        <span className="md-next-button md-multi-button" onClick={nextExtraPeriodButtonPressed}>
          {formatMessage({
            id: "clock.continue.period",
            defaultMessage: "Next Period",
          })}
        </span>
      )}
      {["waitingForExtraPeriodStart", "shootOutInProgress"].includes(clockState) && (
        <span className="md-next-button md-multi-button" onClick={shootOutButtonPressed}>
          {formatMessage({
            id: "clock.shootout",
            defaultMessage: "Shoot-out",
          })}
        </span>
      )}
      {["waitingForExtraPeriodStart", "shootOutInProgress"].includes(clockState) && (
        <span className="md-stop-button md-multi-button" onClick={endMatchButtonPressed}>
          {formatMessage({
            id: "clock.end.fixture",
            defaultMessage: "End Match",
          })}
        </span>
      )}
      {clockState === "waitingForFixtureEnd" && (
        <span className="md-stop-button" onClick={confirmFixtureButtonPressed}>
          {formatMessage({
            id: "clock.confirm.fixture",
            defaultMessage: "Confirm Game",
          })}
        </span>
      )}
      {clockState === "fixtureComplete" && (
        <span className="md-done-button" onClick={confirmFixtureButtonPressed}>
          {formatMessage({
            id: "clock.complete.fixture",
            defaultMessage: "Complete",
          })}
        </span>
      )}
    </>
  );
};

export default injectIntl(MultiDeviceClockButtons);
